<template>
  <!-- 订单雷达页面筛选结果页面 -->
  <div class="rspResult" >
    <div class="leftList" >
      <orderList @getDetail="getDetail" @noListData="noListData"/>
    </div>
    <div class="rightDetails" v-if="!noListDataShow" v-loading="loading">
      <!-- banner图 -->
      <orderBanner/>
      <orderDetails :detailsData="detailsData"  :key="partInfoKey" @getDetail="getDetail" :partner="1"/>
    </div>
    <div v-if="noListDataShow" class="nodataDiv">
      <nodata/>
    </div>
  </div>
</template>

<script>
import orderList from "@/components/zhenyunOrder/orderList"
import orderDetails from "@/components/zhenyunOrder/orderDetails"
import nodata from "@/components/zhenyunOrder/nodata.vue";
import orderBanner from "@/components/zhenyunOrder/orderBanner"
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
export default {
  mixins: [zhenyunOrderMinxis],
  components:{
    orderList,orderDetails,orderBanner,nodata
  },
  data() {
    return{
      detailsData:null,
      loading:false,
      partInfoKey:new Date().getTime(),
      noListDataShow:false
    }
  },
  methods:{
    getDetail(val){
      this.detailsData=null
      this.getRfqDetail(val);
      this.partInfoKey=+new Date().getTime()
    },
    noListData(val){
      this.noListDataShow=val
      if(this.noListDataShow){
        this.detailsData=null
      }
    }
  },
  created(){

  }
};
</script>
<style lang="scss" scoped>
.nodataDiv{
  text-align: center;
  margin: 0 auto;
  // min-width: 1200px;
  width: 100%;
  height: calc(100vh - 273px);
  background: #fff;
}
.rspResult{
  display: flex;
  padding:88px 12px 0 12px;
  .leftList{
    // width: 390px;
    padding-top: 4px;
  }
  .rightDetails{
    padding-top: 4px;
    // min-width: 834px;
    margin-left: 12px;
    position: sticky;
    right: 0;
    left: 400px;
    top: 148px;
    flex: 1;
    margin-left: 16px;
    max-height: calc(100vh - 273px);
    overflow-y: auto;
    // border-radius: 16px 16px 0 0;
    padding-bottom: 24px;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    scrollbar-width: none; /* 隐藏滚动条 */
  }
  .rightDetails::-webkit-scrollbar { width: 0 !important }
}
</style>